var shortVideoDetail = {

    videoVM: null,
    player: null,
    tagSwiper: null,
    productTimes: [],
    closeProductTimes: [], // 手动关闭的产品不再显示
    currentProductIndex: -1, // 当前显示的产品索引
    dragSlider: null,

    toProductDetail:function(url, videoId){
        event.stopPropagation();
        if (url){
            var link = url;
            if (videoId){
                link = link + (link.indexOf('?') > -1 ? '&' : '?') + 'fromvideo=' + videoId;
            }
            window.location.href = link;
        }
    },
    callServer: function(title){
        event.stopPropagation();
        gioTrackAction.shortVideoProductServer(title);
        kefuServer.openServer('',{});
    },

    initVue: function () {
        var _this = this;
        this.videoVM = new Vue({
            el: "#short-video-app",
            data: {
                id: window.videoDetail.id,
                productDesc: '',
                productDescShort: '',
                showShort: true,
                isFold:false,
                collectNumber: 0,
                commentNumber: 0,
                isCollected: false, // 是否收藏
                isSubscript: false, // 是否订阅关注作者
                isDragging: false,
                dragSlidePercent: '',
                playerTime: {
                    duration: 0, // 视频时间
                    currentTime: 0, // 当前时间
                },
                aliPlayerIsPlay: false,// 阿里云播放状态
            },
            mounted: function() {
            },
            computed: {
                videoProcess: function () {
                    if (this.isDragging){
                        return  this.dragSlidePercent + '%';
                    }
                    var process = this.playerTime.currentTime * 100 / this.playerTime.duration;
                    return process + '%';
                },
            },
            created: function () {
                if(window.videoDetail.videoSummary.length > 50){
                    this.isFold = true
                }
                this.productDesc = window.videoDetail.videoSummary;
                //console.log(this.productDesc,window.videoDetail.videoSummaryHtmlFilter)
                this.productDescShort = window.videoDetail.videoSummary.substr(0, 50);
                this.getStateInfo();
            },
            methods: {
                playVideo: function () {
                    _this.player.togglePlayPause();
                    $('.shop-window-container').hide();
                },
                emptyClick: function () {
                },
                sendComment: function () {
                    public_comment_vm.showSendComment();
                },
                showCommentList: function () {
                    public_comment_vm.showAllComment()
                },
                // 异步请求收藏数量，收藏状态，和评论数
                getStateInfo: function () {
                    var _this = this;
                    postJson(window.cateData.api.getCollectionStatus, {
                        'uid': window.cateData.userInfo.memberId,
                        'articleId': this.id
                    }, function (data) {
                        if (data.result > 0) {
                            return;
                        }
                        var stateInfo = data.content[0];
                        _this.collectNumber = stateInfo.collectCount;
                        _this.commentNumber = stateInfo.commentCount;
                        public_comment_vm.commentNumber = _this.commentNumber; // 设置评论模块评论数
                        _this.isCollected = stateInfo.collect ? true : false;
                        _this.isSubscript = stateInfo.authorCollect ? true : false;
                    }, true)
                },
                // 收藏 取消收藏
                collect: function (id, title) {
                    var _this = this, userInfo = isLogin();

                    //判断是否登录
                    var likeText = '点赞并收藏成功';
                    var unLikeText = '点赞/收藏已取消';
                    if (!userInfo) {
                        likeText = '点赞成功';
                        unLikeText = '已取消点赞';
                    }
                    if (status === 'true') {
                        userRecode({behaviorType: '取消收藏', behaviorResult: '无',});
                    } else {
                        userRecode({behaviorType: '收藏', behaviorResult: '无',});
                    }

                    var status = this.isCollected ? 0 : 1,
                        behaviorType = this.isCollected ? '取消收藏' : '收藏';

                    postJson(window.cateData.api.like, {
                        articleId: this.id,
                        status: status,
                        sess: userInfo.session
                    }, function (data) {
                        if (data.result > 0) {
                            loginOut();
                            return;
                        } else {
                            _this.collectNumber = data.total;
                            _this.isCollected = !_this.isCollected;
                            //行为记录
                            userRecode({behaviorType: behaviorType, behaviorResult: title});
                            if (behaviorType === '收藏') {
                                msg.toast(likeText);
                                gioTrackAction.collectSuccess();
                            } else {
                                msg.toast(unLikeText);
                            }
                            window.postMessage({type: 'like', totle: data.total, status: status, id: id}, '*');
                        }
                    }, true);

                    //sess 不对需要登出
                    function loginOut() {
                        delCookie('smarketMember_' + window.cateData.schemaId);
                        gio('clearUserId');
                        //行为记录
                        if (status === 'true') {
                            userRecode({behaviorType: '取消收藏', behaviorResult: '无',});
                        } else {
                            userRecode({behaviorType: '收藏', behaviorResult: '无',});
                        }
                        common.gotoLogin();
                    }
                },

                // 关注、取消关注
                subscript: function () {
                    var usrInfo = isLogin();
                    if (!usrInfo) {
                        //行为记录
                        if (!this.isSubscript) {
                            userAction.focusAuthor('无');
                        } else {
                            userAction.cancelFocusAuthor('无');
                        }
                        common.gotoLogin();
                        return;
                    }
                    var url = window.pcUrl + '/api/interaction/author/' + window.authorId + '/collect/' + (this.isSubscript ? 0 : 1);
                    var _this = this;
                    getJson(url, '', function (data) {
                        if (data.result == 0) {
                            _this.isSubscript = !_this.isSubscript;
                            if (_this.isSubscript) {
                                userAction.focusAuthor(window.authorName);
                            } else {
                                userAction.cancelFocusAuthor(window.authorName);
                            }
                        }
                    }, true)
                },

                // 阿里云视频播放
                playAliVideo: function () {
                    this.aliPlayerIsPlay = true;

                    setTimeout(function () {
                        var video = document.getElementById('ali-video-container');
                        if(!video){
                            return;
                        }
                        video.play();
                        video.muted = false;
                    }, 500)
                }
            }
        })
    },

    // 关闭产品卡片
    closeProductCard: function(timetag){
        event.stopPropagation();
        this.closeProductTimes.push(timetag);
        $('.video-product-' + timetag).attr('style', 'visibility:hidden');
        $('.video-product-' + timetag).removeClass('fadeInRight');
    },

    initPlayer: function () {
        var _this = this;
        var videoHeight = window.screen.availHeight;
        var videoWidth = window.screen.availWidth;

        var videoBoxWidth = videoWidth;
        if (window.videoDetail.videoDirection == 0){
            // 竖屏视频比例 339 / 603
            // videoBoxWidth = videoHeight * 339 / 603 ;
            // if (videoHeight / videoBoxWidth > 661 /375){
            //     videoBoxWidth = videoWidth;
            // }
        }
        console.log(window.innerWidth, window.innerHeight)
        console.log(videoBoxWidth, videoHeight)

        $('.video-vertical-container').width(videoBoxWidth);
        $('.video-vertical-container').css('margin-left', (-(videoBoxWidth - videoWidth)/2)+'px');

        var  playerConfig = {
            containerId: 'tencent-video-container',
            vid: window.videoDetail.videoId,
            width: videoBoxWidth,
            height: videoHeight,
            autoplay: true,
            poster: window.videoDetail.poster,
            isHtml5UseFakeFullScreen: true
        };


        this.player = new Txplayer(playerConfig);

        this.player.on('ready', function () {
            _this.player.on('timeupdate', function (time) {
                // console.log('player timeupdate:', parseInt(time.videoTag.currentTime),_this.player.getDuration());
                if (!_this.videoVM.playerTime.duration) {
                    _this.videoVM.playerTime.duration = _this.player.getDuration();
                }
                var currentTime = parseInt(time.videoTag.currentTime);
                _this.videoVM.playerTime.currentTime = currentTime;
                if (time.videoTag.currentTime > 0){
                    $('.video-process-circle').show();
                }
                // 产品的显示隐藏
                var timetag = getTimeTag(currentTime);
                // var timetagIndex = _this.productTimes.indexOf(timetag.toString());
                if (timetag && _this.closeProductTimes.indexOf(timetag) < 0) {
                    $('.video-product-container').removeClass('fadeInRight');
                    $('.video-product-container').attr('style', 'visibility:hidden');

                    $('.video-product-' + timetag).attr('style', 'visibility:visible');
                    $('.video-product-' + timetag).addClass('fadeInRight');
                }
                if (!_this.dragSlider){
                    _this.dragSlider = new dragSlide('video-process-circle');
                }
                _this.videoVM.isDragging = false;
            });
            function getTimeTag(videoTime) {

                var productNum = _this.productTimes.length;
                var valideIndex = -1;
                for (var i = 0; i < productNum; i++) {
                    var productTime = _this.productTimes[i];
                    var nextProductTime = _this.productTimes[i+1];
                    if (!nextProductTime && videoTime >= productTime && _this.currentProductIndex !== i){
                        valideIndex = i;
                        break;
                    }else if(videoTime >= productTime && videoTime < nextProductTime && _this.currentProductIndex !== i){
                        valideIndex = i;
                        break;
                    }
                }
                _this.currentProductIndex = valideIndex;
                return _this.productTimes[valideIndex];
            }
        });

        this.player.on('playStateChange', function (state) {
            console.log('player playStateChange:', state);
            // -1（未开始） 0（已结束） 1（正在播放）2（已暂停）3（正在缓冲）
            $('.author-info').css('opacity','1');
            $('.video-desc').css('opacity', '1');
            if (state == 0){
                _this.closeProductTimes = [];
            }else if(state == 1 && parseInt(window.videoDetail.showStyle) == 0){
                // 行为记录
                userAction.playVideo();
            }
            if (parseInt(window.videoDetail.showStyle) == 0){
                if (state == 1){
                    // $('.video-vertical-cover').hide();
                    $('.author-info').css('opacity','0');
                    $('.video-desc').css('opacity', '0');
                }else if(state == 0){
                    // $('.video-vertical-cover').show();
                }
            }
        });

        $(document).on('TxPlayerJSBrageReady', function () {
            console.log("123")
        });

        // document.addEventListener('touchmove', function(e) {
        //     e.preventDefault();
        // }, { passive: false });
        function dragSlide(id) {
            this.minDiv = document.getElementById(id); //小方块
            this.width = parseInt(window.getComputedStyle(this.minDiv, null).width); //小方块的宽度
            this.lineDiv = this.minDiv.parentNode; //长线条

            var that = this;
            var lastX = null; //判断鼠标移动方向，解决向左侧滑动时候的bug
            var move = function(e) {
                var x = e.touches[0].pageX,
                    direction = '';
                if (lastX == null) {
                    lastX = x;
                    return;
                }
                if (x > lastX) {
                    direction = 'right';
                } else if (x < lastX) {
                    direction = 'left';
                } else {
                    direction = '';
                }
                var lineDiv_left = that.getPosition(that.lineDiv).left; //长线条的横坐标
                var minDiv_left = x - lineDiv_left; //小方块相对于父元素（长线条）的left值
                if (minDiv_left >= that.lineDiv.offsetWidth - that.width) {
                    minDiv_left = that.lineDiv.offsetWidth - that.width;
                }
                if (minDiv_left < 0) {
                    minDiv_left = 0;
                }
                //设置拖动后小方块的left值
                that.minDiv.style.left = minDiv_left + "px";
                //percent百分比改为如下所示,解决开始和最后滑动的体验不好问题
                var percent = (minDiv_left / (that.lineDiv.offsetWidth - that.width)) * 100;
                if (percent < 0.5 && direction == 'right') {
                    percent = Math.ceil(percent);
                } else if (percent > 0.5 && direction == 'right') {
                    percent = Math.floor(percent);
                } else {
                    percent = Math.ceil(percent);
                }
                _this.videoVM.isDragging = true;
                _this.videoVM.dragSlidePercent = percent;
            }
            //获取元素的绝对位置,工具函数
            this.getPosition = function(node) {
                var left = node.offsetLeft; //获取元素相对于其父元素的left值var left
                var top = node.offsetTop;
                current = node.offsetParent; // 取得元素的offsetParent
                // 一直循环直到根元素

                while (current != null) {
                    left += current.offsetLeft;
                    top += current.offsetTop;
                    current = current.offsetParent;
                }
                return {
                    "left": left,
                    "top": top
                };
            }

            this.minDiv.addEventListener("touchmove", move);
            this.minDiv.addEventListener("touchend", function () {
                if (_this.videoVM.dragSlidePercent){
                    var currentTime =  _this.videoVM.playerTime.duration * _this.videoVM.dragSlidePercent / 100;
                    _this.player.seekTo(currentTime);
                    _this.videoVM.isDragging = false;
                    _this.videoVM.dragSlidePercent = '';
                }
            });
        }
    },

    initVideoTag: function () {
        // console.log($('.swiper-slide-video-tag').length)
        // if ($('.swiper-slide-video-tag').length > 3) {
        //     $('#my-liMarquee').liMarquee();
        // }
        // $(".video-tags-swiper").addClass('swiper-no-swiping')

        this.tagSwiper = new Swiper('.video-tags-swiper', {
            slidesPerView: 'auto',
            freeMode: true,
            // loopedSlides: 5,
            // loop: $('.swiper-slide-video-tag').length > 3,
            // speed: 2000,
            // autoplay: $('.swiper-slide-video-tag').length > 3?{
            //     delay: 0,
            //     stopOnLastSlide: false,
            //     disableOnInteraction: false,
            // }:false,
            slidesOffsetBefore : 15,
            slidesOffsetAfter : 15,
            spaceBetween: 20
        })
        //添加动画
        // var width = $(window).width();
        // $(".notice-bar__wrap").css({'animation-delay': '0s', 'animation-duration': '17.713s','padding-left':width + 'px'});
    },

    initProductEvent: function () {
        var productNum = $('.video-product-container').length, _this = this;
        for (var i = 0; i < productNum; i++) {
            var producttime = $($('.video-product-container')[i]).attr('data-time');
            _this.productTimes.push(producttime);
        }
    },

    // 自定义分享模块
    initCustomShare: function(){

        var url, videoShareImageIsLoaded = false;

        getShareImageUrl();
        function getShareImageUrl() {
            //{//if $detail.showStyle == 0}{//$detail.l_coverImageUrl}{//else/}{//$detail.coverImageUrl}{///if}
            $.ajax({
                url: window.pcUrl + '/api/video/createsharecard',
                method: 'post',
                data: {
                    id: window.videoDetailId,
                    url: window.videoDetail.shareImgUrl
                },
                success: function (res) {
                    var url = 'url('+window.location.origin + res.data+')';
                    $('.coverImg').css('background-image',url)
                    // $('#share-video-coverimg').attr('src', window.location.origin + res.data);
                    initShareImage();
                }
            })
        }

        // 有一些机型视频容器会在最顶层，弹起分享卡片的时候隐藏
        // vivo 隐藏
        function hideVideoContent(){
            var agent = navigator.userAgent.toLowerCase();
            return agent.match(/vivo/i) === 'vivo';
        }

        $('.video-share').click(showShareCard);

        $(".video-share-continaer,#close-share-card-icon").on('click', function () {
            $(".video-share-continaer").css('top', '150%');
            $(".video-share-continaer-mask").hide();
            //显示视频
            $(".video-container .video-content").show();
            userAction.shareClose(window.cateData.userRecodeOption.title + ' 关闭分享');
        });

        function showShareCard() {
            //隐藏视频
            if (hideVideoContent()){
                $(".video-container .video-content").hide();
            }
            $(".video-share-continaer").css('top', '0');
            $(".video-share-continaer-mask").show();

            gioTrackAction.gio_base('videopage_shareclick');
            // 行为记录
            userAction.share(window.cateData.userRecodeOption.title);
        }

        function initShareImage() {
            if (videoShareImageIsLoaded) {
                return;
            }

            var videoId = window.videoDetailId;
            var usershareValue = 'usershare' + videoId;
            var addressLike = window.location.href;
            if (window.location.href.indexOf('mediasources') > -1){
                addressLike = common.changeUrlParams('mediasources',addressLike, usershareValue);
            }else if(window.location.search){
                addressLike = addressLike + '&mediasources=' + usershareValue;
            }else{
                addressLike = addressLike + '?mediasources=' + usershareValue;
            }

            console.log(addressLike);
            if (initWXCustomShare && typeof initWXCustomShare === 'function'){
                initWXCustomShare(addressLike);
            }
            //生成二维码
            $("#qrcode").qrcode({
                render: 'table',
                text: addressLike,
                width: 60,     //设置宽度
                height: 60,      //设置高度
                correctLevel: 1
            });

            //渲染成图片
            html2canvas(document.querySelector("#wrapdom"), {
                useCORS: true,
                logging: true}).then(function (canvas) {
                url = canvas.toDataURL();
                $('.canvasImage').css('display','block');
                $('.card-loading-box').hide();

                // console.log('生成图片链接', url);
                $('.canvasImage').attr('src', url);
                $('.bigcanvasImage').attr('src', url);
                if (!videoShareImageIsLoaded) {
                    videoShareImageIsLoaded = true;
                }
                // $('.video-top').hide();
            }).catch(function (error) {
                console.log('图片生成失败', error)
            });
        }

        //下载图片
        function download() {
            event.stopPropagation();
            $('.bigcanvas-image-box').css('display', 'flex');
            userRecode({behaviorType: '分享', behaviorResult: '{$detail.title}'})
            // var imgData = url;//这里放需要下载的base64
            // downloadFile('{$detail.title}.png', imgData);
        }

        //下载
        function downloadFile(fileName, content) {
            var aLink = document.createElement('a');
            var blob = base64ToBlob(content); //new Blob([content]);
            var evt = document.createEvent("HTMLEvents");
            evt.initEvent("click", true, true);//initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
            aLink.download = fileName;
            aLink.href = URL.createObjectURL(blob);
            aLink.click()
        }

        //base64转blob
        function base64ToBlob(code) {
            var parts = code.split(';base64,');
            var contentType = parts[0].split(':')[1];
            var raw = window.atob(parts[1]);
            var rawLength = raw.length;
            var uInt8Array = new Uint8Array(rawLength);
            for (var i = 0; i < rawLength; ++i) {
                uInt8Array[i] = raw.charCodeAt(i);
            }
            return new Blob([uInt8Array], {type: contentType});
        }
    },

    backhome: function () {
        if (!history.back(-1)){
            window.location.href = '/video';
        }
    },

    showShopWindow: function(){
        $('.shop-window-container').show();
    },

    init: function () {
        this.initVue();
        this.initVideoTag();
        this.initProductEvent();
        var _this = this;
        _this.initPlayer();

        public_comment_vm.commentViewClose = function () {
            _this.videoVM.getStateInfo();
        }
        if (getUrlPara('mediasources') && getUrlPara('mediasources').indexOf('usershare') > -1){
            gioTrackAction.gio_base('videopage_shareURLsuccess');
        }

        // 浏览量增加接口
        common.browseArticle(window.videoDetailId);

        window.onload = function () {
            _this.initCustomShare();
        }
    }
};


